module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/cart-1-fa785c56533ca5959944525f926a0f0f.svg";